// Real Game Used carousel images sourced DIRECTLY from www.realgameused.com asset CDN.
// img1.wsimg.com/isteam/ip/f6017c9d-e427-4e2e-9a8f-98cea9502516/<file>

const RGU_BASE = "https://img1.wsimg.com/isteam/ip/f6017c9d-e427-4e2e-9a8f-98cea9502516";
// Ticker tiles render 200–300px wide. Ask CDN for 420px + q:75 for ~55% smaller payloads
// vs. the old w=600 q=90. Visually identical on non-retina, still crisp on retina at these sizes.
const rgu = (file, w = 420) => `${RGU_BASE}/${file}/:/rs=w:${w},cg:true,m/qt=q:75`;

// CAROUSEL 1 — "RGU Digital Match Gallery" / 1,500+ RGU Photo Matches
// RGU Digital Display photo-match showcases (jersey + match photo composites)
export const PHOTO_MATCH_GALLERY = [
  rgu("RGU_DD_MantleJuly22nd1961_UPDATED.jpg"),
  rgu("RGU_DD_MichaelJordanApril11th1996.jpg"),
  rgu("RGU_DD_MichaelJordan_1993NBAFinals_Game5.png"),
  rgu("RGU_DD_LeBronJames2012TeamUSASneakers.jpg"),
  rgu("RGU_DD_KevinDurantOct28th2023.jpg"),
  rgu("RGU_DD_PatrickMahomesOct7th2018.jpg"),
  rgu("RGU_DD_LukaDoncic_April7th2023.jpg"),
  rgu("RGU_DD_DevinBooker_Nov19th2023.jpg"),
  rgu("RGU_DD_AnthonyEdwards_Nov4th2023.jpg"),
  rgu("RGU_DD_ShaquilleOneal_FinalsGame1.jpg"),
  rgu("RGU_DD_2_JuliusErving_Jan1st1986-2.jpg"),
  rgu("RGU_DD_JoeMontanaNov27th1989.jpg"),
  rgu("RGU_DD_EmmitSmith1989.jpg"),
  rgu("RGU_DD_JimBrown1962.jpg"),
  rgu("RGU_DD_AdrianPeterson_Nov15th2015.jpg"),
  rgu("RGU_DD_CalvinJohnson_Nov5th2015.jpg"),
  rgu("RGU_DD_JJWattSept9th2019.jpg"),
  rgu("RGU_DD_RussellWilson_Oct27th2019.jpg"),
  rgu("RGU_DD_LarryFitzgerald_Oct13th2019.jpg"),
  rgu("RGU_DD_SaquonBarkley_Oct22nd2018.jpg"),
  rgu("RGU_DD_DakPrescottNov18th2018.jpg"),
  rgu("RGU_DD_CamNewton_August29th2021.jpg"),
  rgu("RGUDD_LamarJacksonJan10th2021.jpg"),
  rgu("RGU_DD_MossJersey2003.jpg"),
  rgu("RGU_DD_VickDebutJersey2.jpeg"),
  rgu("RGU_DD_MarlonBrandoPropGun.jpg"),
  rgu("RGU_DD_EddieMurphyLife.jpg"),
];

// CAROUSEL 2 — "Memorabilia Gallery" / Over $35,000,000 Authenticated & 30+ Years
// Raw item photographs (jerseys, signed pieces, big-name items)
export const AUTHENTICATED_GALLERY = [
  rgu("Screen%20Shot%202023-04-13%20at%209.08.10%20AM.png"),
  rgu("IMG_0516.JPG"),
  rgu("4573547567.PNG"),
  rgu("456457.png"),
  rgu("Untitled%20design-2-2.jpg"),
  rgu("IMG_2026.PNG"),
  rgu("IMG_2032.JPG"),
  rgu("1151a1_lg.jpeg"),
  rgu("Attachment_1603620135.jpg"),
  rgu("IMG_2024.PNG"),
  rgu("IMG_2021.PNG"),
  rgu("IMG_2010.PNG"),
  rgu("773l_lg.jpeg"),
];

// CAROUSEL 3 — "Sports, Music & Entertainment Authentication!"
// Exact RGU bs-1 gallery image set (LOAs / photo-match displays for celebrities + athletes)
export const SPORTS_MUSIC_ENT_GALLERY = [
  rgu("1-99858b2.png"),
  rgu("6-7c2c21a.png"),
  rgu("BrianUrlacher_RGU.png"),
  rgu("1-ac25510.png"),
  rgu("3-0050b24.png"),
  rgu("4-a22ce62.png"),
  rgu("Black%20And%20Red%20Modern%20Super%20Mega%20Sale%20B-3344606.png"),
  rgu("Black%20And%20Red%20Modern%20Super%20Mega%20Sale%20B-58fc122.png"),
  rgu("Black%20And%20Red%20Modern%20Super%20Mega%20Sale%20B-0322bfe.png"),
  rgu("MichaelJordanGameJerseyAd.png"),
  rgu("6.png"),
  rgu("Copy%20of%20Black%20And%20Red%20Modern%20Super%20Meg-0eebed7.png"),
  rgu("4-46c2334.png"),
  rgu("Black%20And%20Red%20Modern%20Super%20Mega%20Sale%20Black%20Fri.png"),
  rgu("8.png"),
  rgu("Copy%20of%20Black%20And%20Red%20Modern%20Super%20Mega%20Sale%20B.png"),
  rgu("2-c28b788.png"),
  rgu("3-248ffff.png"),
  rgu("Copy%20of%20Black%20And%20Red%20Modern%20Super%20Meg-772685d.png"),
  rgu("7.png"),
];
